import { UseTranslateResult } from "@tolgee/react";

export type Translatable = {
  translationKey: string;
  subCategories?: Translatable[];
};

export type LocalizedName = {
  name: string;
};

export type LocalizedNameTranslate = UseTranslateResult["t"] | null;

export const resolveLocalizedName = <T extends Translatable>(
  entity: T,
  t: LocalizedNameTranslate
): Omit<T, "name"> & LocalizedName => {
  const fallbackName = (entity as { name?: string }).name ?? "";
  const name =
    t && entity.translationKey ? t(entity.translationKey) : fallbackName;

  return {
    ...entity,
    name,
    ...(entity.subCategories && {
      subCategories: resolveLocalizedNames(entity.subCategories, t),
    }),
  };
};

export const resolveLocalizedNames = <T extends Translatable>(
  entities: T[],
  t: LocalizedNameTranslate
): (Omit<T, "name"> & LocalizedName)[] =>
  entities.map((entity) => resolveLocalizedName(entity, t));
